import type { ui } from '@procuros/datachecks';

export const getFieldLabelsByPath = (uiConfig: Array<ui.Section> | undefined): Record<string, string> => {
  if (!uiConfig) {
    return {};
  }

  const map: Record<string, string> = {};
  for (const section of uiConfig) {
    processSection(section, '', map);
  }
  return map;
};

export const extractLineItemPosition = (jsonpath: string): number | null => {
  const match = jsonpath.match(/^line_items\.(\d+)\./);
  return match ? Number(match[1]) + 1 : null;
};

export const groupNotEnrichedByField = (
  notEnriched: Array<{ jsonpath: string; reason: string }>,
  fieldLabels: Record<string, string>,
): Record<string, Array<{ jsonpath: string; reason: string }>> => {
  const groups: Record<string, Array<{ jsonpath: string; reason: string }>> = {};

  for (const item of notEnriched) {
    const label = getFieldLabel(fieldLabels, item.jsonpath);
    if (!groups[label]) {
      groups[label] = [];
    }
    groups[label].push(item);
  }

  return groups;
};

export const getFieldLabel = (fieldLabels: Record<string, string>, jsonpath: string): string => {
  const normalized = jsonpath.replace(/\[\d+\]/g, '');
  const parts = normalized.split('.');

  for (let i = 0; i < parts.length - 1; i++) {
    const candidate = parts.slice(i).join('.');
    if (fieldLabels[candidate]) {
      return fieldLabels[candidate];
    }
  }

  return parts[parts.length - 1] ?? jsonpath;
};

const processSection = (section: ui.Section, parentPath: string, map: Record<string, string>) => {
  const sectionPath = parentPath ? `${parentPath}.${section.path}` : section.path;

  if ('fields' in section && Array.isArray(section.fields)) {
    for (const field of section.fields) {
      if (field.label) {
        map[`${sectionPath.replace('$.', '')}.${field.path}`] = field.label;
      }
    }
  }

  if ('sections' in section && Array.isArray(section.sections)) {
    for (const sub of section.sections) {
      processSection(sub as ui.Section, sectionPath, map);
    }
  }
};
